// MISCELLANEOUS
// ===================================================

var misc = {

    settings: {
        accordions: $('.js-expand-button'),
        link_style_chevron: $('.link-style-chevron'),
        people_pages_with_blocks: $('body.single-people .has-gutenberg-blocks'),
    },

    init: function() {
        // Accordions
        if (this.settings.accordions.length) {
            this.accordions();
        }
        // Links - Boxed Chevron Style
        if (this.settings.link_style_chevron.length) {
            this.linkStyleChevron();
        }
        // People Page Modifications
        if (this.settings.people_pages_with_blocks.length) {
            this.peoplePageBlocks();
        }
        // Clean up spacing on blocks
        this.sectionPaddingCleanup();
    },

    // Expand/Collapse Accordions
    accordions: function() {

        misc.settings.accordions.on('click', function() {
            if (!$(this).hasClass('active')) {
                $(this).addClass('active');
                // Find the content via parent element
                $(this).closest('.js-expand-parent').find('.js-expand-content').slideDown(250);
            } else {
                $(this).removeClass('active');
                // Find the content via parent element
                $(this).closest('.js-expand-parent').find('.js-expand-content').slideUp(250);
            }
        });

    },

    // Add html to links with boxed chevron styling
    linkStyleChevron: function() {
        
        misc.settings.link_style_chevron.each(function() {
            var html = '<span class="chevron"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.06 12.71"><polygon points=".71 12.71 0 12 5.65 6.35 0 .71 .71 0 7.06 6.35 .71 12.71"/></svg></span>';
            $(this).prepend(html);
        });

        // Remove <p> wrapping element for hero links
        var links = $('.block-hero .content .link-style-chevron');
        if (links.length) {
            links.each(function() {
                if ($(this).parent()[0].nodeName == 'P') {
                    $(this).unwrap();
                }
            });
        }

    },

    // Modify the resources slider background color depending on the block preceding it
    peoplePageBlocks: function() {

        // Resources slider has a gray background by default. Change to white if the previous block is gray.
        var resource_slider = $('#main .block-resources-slider');
        var previous_block = resource_slider.prev();

        if (previous_block.hasClass('bg-gray')) {
            resource_slider.removeClass('bg-gray');
            resource_slider.addClass('bg-white');
        }

    },

    // Example: 2 consecutive sections have a white background - Remove the padding from one of those to make spacing consistent without having to mess with top/bottom padding options for each block
    sectionPaddingCleanup: function() {

        // Current background options:
        // bg-blue, bg-gray, bg-white

        // Loop through all blocks with a set background color
        $('#main section[class*="bg-"], #main .gutenberg-wrapper').each(function() {
            // Get the background color to compare
            if ($(this).hasClass('bg-blue')) {
                var bg = 'bg-blue';
            }
            else if ($(this).hasClass('bg-gray')) {
                var bg = 'bg-gray';
            }
            else if ($(this).hasClass('bg-white')) {
                var bg = 'bg-white';
            }
            // Compare that to the next section
            if ($(this).next().hasClass(bg)) {
                $(this).addClass('no-bottom-padding');
            }
        });
        
    },

};
misc.init();